const handler = ( $ ) => {
	$( '.js-media-carousel' ).each( function () {
		const $carousel = $( this );
		const $track = $carousel.find( '.media-carousel__track' );
		if ( ! $track.length ) {
			return;
		}

		const $prev = $carousel.find( '.media-carousel__prev' );
		const $next = $carousel.find( '.media-carousel__next' );
		const $nav = $carousel.find( '.media-carousel__nav' );
		const $current = $carousel.find( '.media-carousel__current' );
		const $total = $carousel.find( '.media-carousel__total' );
		const $progress = $carousel.find( '.media-carousel__progress span' );

		const formatCount = ( value ) =>
			value < 10 ? `0${ value }` : `${ value }`;

		const updateCounter = ( slick, currentSlide ) => {
			const index = currentSlide + 1;
			if ( $current.length ) {
				$current.text( formatCount( index ) );
			}
			if ( $total.length ) {
				$total.text( formatCount( slick.slideCount ) );
			}
			if ( $progress.length ) {
				const percent = ( index / slick.slideCount ) * 100;
				$progress.css( 'width', `${ percent }%` );
			}
		};

		const updateNav = ( slick ) => {
			if ( ! $nav.length ) {
				return;
			}

			const hasMultipleSlides = slick.slideCount > 1;
			$nav.toggleClass( 'is-hidden', ! hasMultipleSlides );
			$nav.attr( 'aria-hidden', hasMultipleSlides ? 'false' : 'true' );
		};

		const updateSlideWidth = () => {
			const isNarrow = window.matchMedia( '(max-width: 1299.98px)' ).matches;
			if ( ! isNarrow ) {
				$carousel[ 0 ].style.removeProperty( '--media-carousel-slide-width' );
				return;
			}

			const $widthSource = $carousel
				.closest( '.case-study-section__body, .case-study-hero__main' )
				.first();
			const widthTarget = $widthSource.length ? $widthSource : $carousel;
			const slideWidth = Math.round( widthTarget.innerWidth() );

			$carousel[ 0 ].style.setProperty(
				'--media-carousel-slide-width',
				`${ slideWidth }px`
			);
		};

		let resizeTimer;
		const handleResize = () => {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( () => {
				updateSlideWidth();
				if ( $track.hasClass( 'slick-initialized' ) ) {
					$track.slick( 'setPosition' );
				}
			}, 100 );
		};

		$track.on(
			'init reInit afterChange',
			function ( event, slick, currentSlide ) {
				updateCounter( slick, currentSlide || 0 );
				updateNav( slick );
				updateSlideWidth();
			}
		);

		$track.slick( {
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			adaptiveHeight: false,
			variableWidth: true,
			prevArrow: $prev,
			nextArrow: $next,
			appendArrows: $nav.length ? $nav : $carousel,
		} );

		$( window ).on( 'resize', handleResize );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
